module.exports = __webpack_public_path__ + "img/logo.21a0cc68.svg";